module.exports = __webpack_public_path__ + "assets/65f7dadcb7412e24880f6e9e668eb365.png";